import { PANEL_TYPES, PANEL_LEVEL } from './panelTypes';

/**
 * PURPOSE_TO_PANEL_TYPE_MAP - kullanimAmac / label / code -> panelTypeId eşleme
 * Tüm panel tipleri için olası değerler
 */
export const PURPOSE_TO_PANEL_TYPE_MAP = {
  // Birincil panel tipleri
  'Müşterek': 'GT',
  'GT': 'GT',
  'Mesken': 'MESKEN',
  'MESKEN': 'MESKEN',
  'İşYeri': 'ISYERI',
  'ISYERI': 'ISYERI',
  'İşyeri': 'ISYERI',
  'Asansör': 'ASANSOR',
  'ASANSOR': 'ASANSOR',
  // GT Alt Panelleri - code
  'THP': 'THP',
  'SP': 'SP',
  'OP': 'OP',
  'KDP': 'KDP',
  // GT Alt Panelleri - label
  'Teknik Hol Panosu': 'THP',
  'Sığınak Panosu': 'SP',
  'Otopark Pano': 'OP',
  'Kazan Dairesi Pano': 'KDP',
};

/**
 * canAddChildPanel - Hiyerarşi doğrulama
 * @param {string} parentTypeId - Üst panel tipi ID
 * @param {string} childTypeId - Alt panel tipi ID
 * @param {object} panelTypes - Panel tipleri objesi (varsayılan: PANEL_TYPES)
 * @returns {boolean}
 */
export function canAddChildPanel(parentTypeId, childTypeId, panelTypes = PANEL_TYPES) {
  const parentType = panelTypes[parentTypeId];
  if (!parentType) return false;
  return parentType.allowedChildPanels.includes(childTypeId);
}

/**
 * getChildPanelTypes - İzin verilen alt panel tiplerini döndürür
 * @param {string} panelTypeId - Panel tipi ID
 * @param {object} panelTypes - Panel tipleri objesi (varsayılan: PANEL_TYPES)
 * @returns {Array} Alt panel tipleri dizisi
 */
export function getChildPanelTypes(panelTypeId, panelTypes = PANEL_TYPES) {
  const panelType = panelTypes[panelTypeId];
  if (!panelType) return [];
  return panelType.allowedChildPanels
    .map(childId => panelTypes[childId])
    .filter(Boolean);
}

/**
 * getPrimaryPanelTypes - Birincil panel tiplerini döndürür
 * @param {object} panelTypes - Panel tipleri objesi (varsayılan: PANEL_TYPES)
 * @returns {Array}
 */
export function getPrimaryPanelTypes(panelTypes = PANEL_TYPES) {
  return Object.values(panelTypes).filter(pt => pt.level === PANEL_LEVEL.PRIMARY);
}

/**
 * getGTChildPanelTypes - GT alt panel tiplerini döndürür
 * @param {object} panelTypes - Panel tipleri objesi (varsayılan: PANEL_TYPES)
 * @returns {Array}
 */
export function getGTChildPanelTypes(panelTypes = PANEL_TYPES) {
  return Object.values(panelTypes).filter(pt => pt.level === PANEL_LEVEL.GT_CHILD);
}
